/* eslint-disable */
export default {
  cancel: 'Annuler',
  close: 'Fermer',
  ok: 'OK',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"close"@#@ @source: @#@"Close"@#@
// @key: @#@"ok"@#@ @source: @#@"OK"@#@
